<template>
<div class="modal h-100" ref="modal" id="settings" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document" :style="licenseExpMess && licenseExpMess.trim().length?'height:calc(100% - 30px)':'height:100%'">
    <div class="modal-content full-screen-settings">
      <div class="modal-header p-2">
        <h4 class="modal-title mt-2 ml-2">{{$t('Jobs')}}</h4>
        <button type="button" class="close text-white" data-dismiss="modal" :style="close" aria-label="Close" @click="close">
          <span aria-hidden="true"><h2><cancel-icon class="close-icon" style="height: 35px !important;
    width: 35px !important;
    color: #fff;"></cancel-icon></h2></span>
        </button>
      </div>
      <div style="height:50px;border-bottom: 1px solid #1e1e1e;padding-top:5px;" class="filter-fields-in-logs w-100">
        <li style="width:30%">
          <div style="display: inline-flex" class="w-100">
            <div class="d-inline-flex edit-icon-visibility search-bar-comm-style comm-div" style="width:100%;">
              <input
                type="text"
                v-model="filterBy.resource_name"
                class="bg-transparent rounded text-light w-100"
                placeholder="Search by file name..."
                @keyup.enter="searchResourceName"
              />
              <!-- <svg
                width="1em"
                height="1em"
                viewBox="0 0 16 16"
                class="bi bi-search"
                fill="#c5c0c0"
                xmlns="http://www.w3.org/2000/svg"
                @click="searchResourceName"
               >
                <path fill-rule="evenodd" d="M10.442 10.442a1 1 0 0 1 1.415 0l3.85 3.85a1 1 0 0 1-1.414 1.415l-3.85-3.85a1 1 0 0 1 0-1.415z"/>
                <path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"/>
              </svg> -->
            </div>
          </div>
        </li>
        <!-- <div class="comm-div" style="margin-inline-start:2%">
          <label>Jobname</label>
          <select class="bg-transparent rounded text-light pl-1" style="width:70%"
           v-model="filterBy.job_name" @change="updateJobsListFromServer(false,true)">
           <option value="All" selected>All</option>
            <option v-for="item in getJobNames()" :key="item.action_name" :value="item.action_name">{{item.label}}</option>
          </select>
        </div> -->
        <li style="width: 40%;">
            <div class="config-label">{{$t('Job name')}}</div>
            <div class="config-value">
                <div style="display: inline-flex" class="w-100">
                    <div class="d-inline-flex edit-icon-visibility" style="width:100%;">
                        <Multiselect
                            v-model="selectedJobName"
                            :options="getJobNames()"
                            :searchable="true"
                            :close-on-select="true"
                            :allow-empty="false"
                            label="label"
                            track_by="action_name"
                            :showNoOptions="false"
                            deselectLabel=""
                            selectLabel=""
                            selectedLabel=""
                            style="margin-inline-start:6px;"
                            @select="updateJobNameFilter($event)"
                            :track-by="getJobNames.job_status">
                            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                <span style="margin-inline-start:12px;">{{ $t(scope.option.label) }}</span>
                            </div>
                            <span slot="noResult">No results.</span>
                        </Multiselect>
                    </div>
                </div>       
            </div>
        </li>

        <!-- <div>
          <label>Status</label>
          <select class="bg-transparent rounded text-light pl-1" style="width:70%"
           v-model="filterBy.state" @change="updateJobsListFromServer(false,true)">
           <option value="All" selected>All</option>
            <option v-for="(item , index) in allJobsStatuses" v-bind:key="index" :value="item.job_status">{{item.label}}</option>
          </select>
        </div> -->
        <li>
            <div class="config-label">{{$t('Status')}}</div>
            <div class="config-value">
                <div style="display: inline-flex" class="w-100">
                    <div class="d-inline-flex edit-icon-visibility" style="width:100%;">
                        <Multiselect
                            :value="selectedJobStatus.label"
                            :options="allJobsStatuses"
                            :searchable="false"
                            :close-on-select="true"
                            :allow-empty="false"
                            :label="filterBy.job_status"
                            :showNoOptions="false"
                            deselectLabel=""
                            selectLabel=""
                            selectedLabel=""
                            style="margin-inline-start:6px;"
                            @select="updateStatusFilter($event)"
                            :track-by="allJobsStatuses.job_status">
                            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                <span style="margin-inline-start:12px;">{{ $t(scope.option.label) }}</span>
                            </div>
                            <span slot="noResult">No results.</span>
                        </Multiselect>
                    </div> 
                </div>       
            </div>
        </li>

        <!-- <div class="comm-div" style="margin-inline-start:1%">
          <label>User</label>
          <div class="value-style d-inline-flex w-100" style="inset-inline-end:0px;bottom:8px;position:relative">
           <input
              @focus="getusersOnKeyup"
              v-on:keyup="getusersOnKeyup"
              placeholder="select user"
              type="text"
              v-model="searchByUser"
              class="bg-transparent rounded text-light w-100 pl-2"
            />
            <div class="panel-footer autocomplete-box col-xl-12 p-2"
             v-show="userListFromAutocomplete.length > 0" style="position:absolute;top:100%">
              <ul class="list-group" v-click-outside="hideUsersDropdown">
                <li v-for="userInfo in userListFromAutocomplete"
                 :key="userInfo._id"
                  @click="filterBy.user_id=userInfo._id;searchByUser=userInfo.username; updateJobsListFromServer(false,true);userListFromAutocomplete = []" 
                  class="list-group-item autocomplete-box-li m-0 p-0">
                      {{ userInfo.username }}
                </li>
              </ul>
            </div>
          </div>
        </div> -->
         <li>
            <div class="config-label">{{$t('Users')}}</div>
            <div class="config-value">
                <div style="display: inline-flex" class="w-100">
                    <div class="d-inline-flex edit-icon-visibility" style="width:100%;">
                        <user-multi-select
                            :isSearchable="isViewJobPrivExists('jobs')"
                            :enableCheckbox="false"
                            :enableAllOption="true"
                            @updatedUsersList="handleUpdatedUsersList" 
                            :selectedUserIdList="('user_id' in filterBy)?filterBy.user_id:[]"
                        >
                        </user-multi-select>
                    </div> 
                </div>       
            </div>
        </li>


        <li class="comm-div">
          <div class="config-label">{{$t('Date')}}</div>
          <div class="config-value">
            <div style="display: inline-flex" class="w-100">
              <div :title='time1' class="d-inline-flex edit-icon-visibility" style="width:100%;">
                <Datepicker
                  range
                  :value="time1"
                  @focus="showUserFilter=false"
                  valueType="format"
                  @change="filterJobsByDate($event)"
                  class="bg-transparent rounded  text-light"
                  @clear="clearDateRangeFilter()"
                >
                </Datepicker>
              </div>
            </div>
          </div>
        </li>
        <!-- <div style="inset-inline-start:0%" class="pt-2">
          <div @click="foldAndUnfoldAllJobs" style="width: 60px;height: 25px;padding: 0px;border-radius: 4px;background: #1e1e1e;">
            <span v-if="isUnfold.length" style="margin-inline-start:16px;margin-top:2px">Fold</span>
            <span v-else style="margin-inline-start:8px;margin-top:2px">UnFold</span>
          </div>
        </div> -->
        <li class="primary-btn-style justify-content-end"  style="padding: 0px !important;display:inline-block;margin: 0px !important;float:inline-start;width:55px;">
            <button @click="searchResourceName()" class="btn btn-outline-secondary" style="width: 45px; margin: 0; margin-inline-start: 9px; padding: 6px;">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                </svg>
            </button>
        </li>
        <li class="comm-div" style="width:16%;justify-content: flex-end;">
          <button class="btn  btn-outline-secondary common-action-btn refresh-action" title="Refresh"
             @click="page=1,handleJobsBrowse(true)">
              <span class="common-action-label-icon">
                <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 24 24" width="18" fill="currentColor">
                  <path d="M0 0h24v24H0V0z" fill="none"/>
                  <path d="M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"/>
                </svg>
              </span>
              {{$t('Refresh')}}
            </button>
        </li>
      </div>

      <div class="user-logs-table" style="margin-top: 16px;padding: 0px 15px">
      <table class="tabletable-with-border table-scroll small-first-col"  style="background: transparent">
      <thead style="color: #eee">
        <tr>
          <th style="width: 2%"></th>
          <th style="width: 32%">{{$t('Slugname')}}</th>
          <th style="width: 9%">{{$t('Job name')}}</th>
          <th style="width: 11%">{{$t('Status')}}</th>
          <th style="width: 7%;text-align:center">{{$t('Date Created')}}</th>
          <th style="width: 8%;text-align:center">{{$t('Size')}}</th>
          <th style="width: 9%">{{$t('Username')}}</th>
          <th style="width: 5%;text-align:center">{{$t('Priority')}}</th>
          <th style="width: 7%">{{$t('Node id')}}</th>
          <th style="width: 6%;text-align:center">{{$t('Worker')}}</th>
          <th style="width: 2%"></th>
          <!-- <th style="width: 20%">Error description</th> -->
        </tr>
      </thead>
      <tbody class="body-half-screen">
        <template v-for="parentJobEntry in jobsListWithSubJobs">
        <tr  class="ccomm-logs-row" :class="{activeclass: activeIndex === parentJobEntry}" :key="parentJobEntry._id">            
          <td>
            <div v-if="mapFistLevelWithSubLevelJobs[parentJobEntry.group_id] && mapFistLevelWithSubLevelJobs[parentJobEntry.group_id].length > 0" type="button" class="btn text-white p-0 pl-2" style="position: relative;bottom:4px;">
               <svg :ref="'fold'+parentJobEntry.group_id" v-on:click="updateUnFoldJobsMap(parentJobEntry.group_id,$event)" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-right foldIcon" fill="#C5C0C0" xmlns="http://www.w3.org/2000/svg">
                   <path fill-rule="evenodd" stroke="#C5C0C0" stroke-width="2" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
                 </svg>
                <svg :ref="'unfold'+parentJobEntry.group_id" v-on:click="updateFoldJobsMap(parentJobEntry.group_id,$event)" width="15" height="15" viewBox="0 0 16 16" class="bi bi-chevron-down unFoldIcon" fill="#C5c0c0" xmlns="http://www.w3.org/2000/svg">
                   <path fill-rule="evenodd" stroke="#C5C0C0" stroke-width="2" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                 </svg>
            </div>
          </td>
          <td v-on:click="showSelectedJobDetails(parentJobEntry)" class="text-left underline-on-hover" style="text-transform: capitalize;display:inline-flex;float:inline-start;width:100%;overflow-wrap: anywhere;">
            <span style="margin-top:8px;margin-inline-end:10px" v-if="parentJobEntry.data && parentJobEntry.data.slug_name">{{parentJobEntry.data.slug_name}}</span>
            <span style="margin-top:8px;margin-inline-end:10px;" v-else>{{parentJobEntry.resource_name?parentJobEntry.resource_name:'-'}}</span>
          </td>
          <td class="text-left" style="text-transform: capitalize;">{{parentJobEntry.job_name}}</td>
          <td class="text-left" style="text-transform: capitalize;">
            <div class="d-flex">
              <div v-if="parentJobEntry.state == 'COMPLETED'">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#57af57" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
                  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                </svg>
              </div>
              <div v-if="parentJobEntry.state == 'FAILED' || parentJobEntry.state == 'ABORTED'">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#cc6464" class="bi bi-x-circle-fill" viewBox="0 0 16 16">
                  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
                </svg>
              </div>
              <div v-if="parentJobEntry.state == 'QUEUED'">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="orange" class="bi bi-clock-fill" viewBox="0 0 16 16">
                  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/>
                </svg>
              </div>
              <div v-if="parentJobEntry.state == 'IN_PROGRESS'" style="display:inline-flex;width:96%">
                <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="orange" class="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                  <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                </svg> -->
                <div class="progress">
                  <div :id="parentJobEntry.job_id" class="progress-bar" role="progressbar" :style="{'width':parentJobEntry.status_info.progress+'%'}" :aria-valuenow="parentJobEntry.status_info.progress" aria-valuemin="0" aria-valuemax="100">{{parseInt(parentJobEntry.status_info.progress) + "%"}}</div>
                </div>
                <div v-if="parentJobEntry.status_info && parentJobEntry.status_info.bandwidth" style="font-size:11px;width:35%">{{humanizeBandwidth(parentJobEntry.status_info.bandwidth).bandwidth}} {{humanizeBandwidth(parentJobEntry.status_info.bandwidth).unit}}</div>
              </div>
              <span class="ml-2" v-if="parentJobEntry.state != 'IN_PROGRESS'">{{parentJobEntry.state}}</span>
              <button v-if="['FAILED','ABORTED'].includes(parentJobEntry.state) && parentJobEntry.job_name != 'Upload'" v-on:click="retryJob(parentJobEntry)" style="color: #007bff;margin-inline-start: 10px;text-decoration: underline;font-size: 12px;font-size: 12px;">
                {{$t('Retry')}} 
              </button>
            </div>
            </td>
          <!-- <td style="text-transform: capitalize;text-align:center">{{formatedDate(parentJobEntry.created_datetime)}}</td> -->
          <td style="text-transform: capitalize;text-align:center" :title="getDateAndTimeInConfiguredFormat(parentJobEntry.created_datetime)">{{checkIsTodayoryesterdayDate(parentJobEntry.created_datetime) ? getDateAndTimeInConfiguredFormat(parentJobEntry.created_datetime, true) : getDateAndTimeInConfiguredFormat(parentJobEntry.created_datetime)}}</td>
          <td class="text-center" style="text-transform: capitalize;">{{parentJobEntry.data?humaniseSize(parentJobEntry.data.size):'-'}}</td>
          <td class="text-left" style="text-transform: capitalize;">{{getUserNameFromId(parentJobEntry.user_id)}}</td>
          <!-- <td class="text-left" style="text-transform: capitalize;">
            <span v-if="parentJobEntry.error_message.length > 0">{{parentJobEntry.error_message}}</span>
            <span v-else>-</span>
            </td> -->
          <td  @click="editPriority(parentJobEntry.job_id)">
            <div v-if="choosePriority == parentJobEntry.job_id && ['QUEUED'].includes(parentJobEntry.state)">
              <Multiselect
                :ref="'priority'+parentJobEntry.job_id"
                :options="priorityMapper"
                :searchable="false"
                :close-on-select="true"
                :allow-empty="false"
                label="value"
                track_by="id"
                :showNoOptions="false"
                deselectLabel=""
                selectLabel=""
                selectedLabel=""
                placeholder="Select priority"
                style="margin-inline-start:6px;width: 120px;position: absolute"
                @open="decideOpenDirection($event,'priority'+parentJobEntry.job_id)"
                :appendToBody="true"
                :openDirection="dropdownOpenDirection"
                @select="handleJobPriority($event, parentJobEntry.job_id)">
                  <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                    <svg class="svg-icon" fill="currentColor" v-html="getPriorityIcon(scope.option.value)" style="width:15px;height:15px;display:inline-block"> </svg> 
                    <span style="margin-inline-start:12px;">{{ scope.option.value }}</span>
                  </div>
                  <span slot="noResult">No results.</span>
              </Multiselect>
            </div>
            <template v-else>
              <div v-if="Object.keys(parentJobEntry).includes('priority') && parentJobEntry.priority != null" class="priority-wrapper">
                <svg v-if="parentJobEntry.priority==1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up svg-icon" viewBox="0 0 16 16">
                  <title>Highest</title>
                  <path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z" fill="#fb3a0e" stroke="#fb3a0e"/>
                </svg>
                <svg v-else-if="parentJobEntry.priority==2" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up svg-icon" viewBox="0 0 16 16">
                  <title>High</title>
                  <path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z" fill="#fb572f" stroke="#fb572f"/>
                </svg>
                <svg v-else-if="parentJobEntry.priority==3" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up svg-icon" viewBox="0 0 16 16">
                  <title>Medium</title>
                  <path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z" fill="#f7ab00" stroke="#f7ab00"/>
                </svg>
                <svg v-else-if="parentJobEntry.priority==4" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-down svg-icon" viewBox="0 0 16 16"  stroke="#b5b5b5">
                  <title>Low</title>
                  <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"/>
                </svg>
                <svg v-else-if="parentJobEntry.priority==5" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-down svg-icon" viewBox="0 0 16 16" stroke="#808080">
                  <title>Lowest</title>
                  <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"/>
                </svg>
                <svg v-if="['QUEUED'].includes(parentJobEntry.state)" @click="editPriority(parentJobEntry.job_id)" data-v-03cf0b88=""
                 xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#939393" style="position: absolute;inset-inline-end :11px;"
                  viewBox="0 0 16 16" class="bi bi-caret-down-fill align-icons priority-icon">
                  <path data-v-03cf0b88="" d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z">
                  </path>
                </svg>
              </div>
              <span v-else class="validationmessage">-</span>
            </template>
          </td>
          <td class="text-left">
            <span v-if="'node_id' in parentJobEntry" style="word-break: break-all">{{parentJobEntry.node_id}}</span>
            <span v-else>-</span>
          </td>
          <td style="text-transform: capitalize;">
            <span v-if="'job_worker' in parentJobEntry && parentJobEntry.job_worker" style="word-break: break-all">{{parentJobEntry.job_worker}}</span>
            <span v-else>-</span>
          </td>
          <td>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" v-on:click="showSelectedJobDetails(parentJobEntry)" class="bi bi-info-circle-fill jobs-info-icon" viewBox="0 0 16 16">
              <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
            </svg>
          </td>
        </tr>
        <!-- <template v-if="!isUnfold"> -->
        <template  v-for="subjob in mapFistLevelWithSubLevelJobs[parentJobEntry.group_id]">
          <tr class="ccomm-logs-row ml-4 comm-sub-job-rows" :class="'sub'+parentJobEntry.group_id" :ref="parentJobEntry.group_id" :key="subjob._id+parentJobEntry._id">
          <td></td>
          <td v-on:click="showSelectedJobDetails(subjob)" class="text-left underline-on-hover" style="text-transform: capitalize;position:relative;inset-inline-start:1%;">
            <span v-if="'slug_name' in subjob.data && ![null, undefined].includes(subjob.slug_name)" style="float: inline-start;overflow-wrap: anywhere;margin-inline-end: 33px;">{{subjob.data.slug_name}}</span>
            <span v-else style="float: inline-start;overflow-wrap: anywhere;margin-inline-end: 33px;">{{subjob.resource_name?subjob.resource_name:'-'}}</span>
          </td>
          <td class="text-left" style="text-transform: capitalize;">{{subjob.job_name}}</td>
          <td class="text-left" style="text-transform: capitalize;">
            <div class="d-flex">
              <div v-if="subjob.state == 'COMPLETED'">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#57af57" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
                  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                </svg>
              </div>
              <div v-if="subjob.state == 'FAILED' || subjob.state == 'ABORTED'">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#cc6464" class="bi bi-x-circle-fill" viewBox="0 0 16 16">
                  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
                </svg>
              </div>
              <div v-if="subjob.state == 'QUEUED'">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="orange" class="bi bi-clock-fill" viewBox="0 0 16 16">
                  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/>
                </svg>
              </div>
              <span class="ml-2" v-if="subjob.state == 'QUEUED'">{{subjob.state}}</span>
              <span class="ml-2" v-else>{{subjob.state}}</span>
              <button v-if="['FAILED','ABORTED'].includes(subjob.state)" v-on:click="retryJob(subjob)" style="color: #007bff;margin-inline-start: 10px;text-decoration: underline;font-size: 12px;">
                  {{$t('Retry')}}
              </button>
            </div>
            </td>
          <!-- <td class="text-center" style="text-transform: capitalize;">{{formatedDate(subjob.created_datetime)}}</td> -->
          <td class="text-center" style="text-transform: capitalize;">{{getDateAndTimeInConfiguredFormat(subjob.created_datetime, true)}}</td>
          <td class="text-center" style="text-transform: capitalize;">{{humaniseSize(subjob.data.size)}}</td>
          <td class="text-left" style="text-transform: capitalize;">{{getUserNameFromId(subjob.user_id)}}</td>
          <td @click="editPriority(subjob.job_id)">
            <div v-if="choosePriority == subjob.job_id && ['QUEUED'].includes(subjob.state)">
              <Multiselect
                :ref="'priority'+subjob.job_id"
                :options="priorityMapper"
                :searchable="false"
                :close-on-select="true"
                :allow-empty="false"
                label="value"
                track_by="id"
                :showNoOptions="false"
                deselectLabel=""
                selectLabel=""
                selectedLabel=""
                placeholder="Select priority"
                style="margin-inline-start:6px;width: 120px;position: absolute"
                @open="decideOpenDirection($event,'priority'+subjob.job_id)"
                :appendToBody="true"
                :openDirection="dropdownOpenDirection"
                @select="handleJobPriority($event, subjob.job_id, parentJobEntry.group_id)">
                  <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                    <svg class="svg-icon" fill="currentColor" v-html="getPriorityIcon(scope.option.value)" style="width:15px;height:15px;display:inline-block"> </svg> 
                    <span style="margin-inline-start:12px;">{{ scope.option.value }}</span>
                  </div>
                  <span slot="noResult">No results.</span>
              </Multiselect>
            </div>
            <template v-else>
              <div v-if="Object.keys(subjob).includes('priority') && subjob.priority != null" class="priority-wrapper">
                <svg v-if="subjob.priority==1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up svg-icon" viewBox="0 0 16 16">
                  <title>Highest</title>
                  <path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z" fill="#fb3a0e" stroke="#fb3a0e"/>
                </svg>
                <svg v-else-if="subjob.priority==2" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up svg-icon" viewBox="0 0 16 16">
                  <title>High</title>
                  <path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z" fill="#fb572f" stroke="#fb572f"/>
                </svg>
                <svg v-else-if="subjob.priority==3" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up svg-icon" viewBox="0 0 16 16">
                  <title>Medium</title>
                  <path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z" fill="#f7ab00" stroke="#f7ab00"/>
                </svg>
                <svg v-else-if="subjob.priority==4" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-down svg-icon" viewBox="0 0 16 16"  stroke="#b5b5b5">
                  <title>Low</title>
                  <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"/>
                </svg>
                <svg v-else-if="subjob.priority==5" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-down svg-icon" viewBox="0 0 16 16" stroke="#808080">
                  <title>Lowest</title>
                  <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"/>
                </svg>
                <svg v-if="['QUEUED'].includes(subjob.state)" @click="editPriority(subjob.job_id)" data-v-03cf0b88=""
                 xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#939393" style="position: absolute;inset-inline-end :11px;"
                 viewBox="0 0 16 16" class="bi bi-caret-down-fill align-icons priority-icon">
                  <path data-v-03cf0b88="" d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z">
                  </path>
                </svg>
              </div>
              <span v-else class="validationmessage">-</span>
            </template>
          </td>
          <td class="text-left">
            <span v-if="'node_id' in subjob" style="word-break: break-all">{{subjob.node_id.split(" ")[0]}}</span>
            <span v-else>-</span>
          </td>
          <td style="text-transform: capitalize;">
            <span v-if="'job_worker' in subjob && subjob.job_worker" style="word-break: break-all">{{subjob.job_worker.split(" ")[0]}}</span>
            <span v-else>-</span>
          </td>
          <td>
            <!-- <svg v-if="subjob.state != 'COMPLETED'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" v-on:click="retryJob(subjob)" style="margin-inline-end: 5px" class="bi bi-arrow-clockwise " viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
              <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
              <title>Retry</title>
            </svg> -->
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" v-on:click="showSelectedJobDetails(subjob)" class="bi bi-info-circle-fill jobs-info-icon" viewBox="0 0 16 16">
              <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
            </svg>
          </td>
           <!-- <td class="text-left" style="text-transform: capitalize;">
            <span v-if="subjob.error_message.length > 0">{{subjob.error_message}}</span>
            <span v-else>-</span>
            </td>  -->
        </tr>
        </template>
        </template>
         <!-- </template> -->
      </tbody>
    </table>
    <h5 v-if="jobsListWithSubJobs.length == 0" class="p-4">No Data Found</h5>
      </div>
      <div style="background:#1a1a1a;height:50px">
      <!-- <div style="position:absolute;float:inline-start;padding:9px;color: #d19b58;
    font-size: 12px;">Total Queued and In progress jobs: <span style="color:#eee;position: relative;top: 1px;font-size: 14px;">{{inProgressJobsCount}}</span></div> -->
    <button type="button" class="btn btn-outline-dark load-more-btn" @click="loadMoreJobs" v-if="isLoadMore">Load More</button>
    <div style="width:300px;display:inline-flex;height:100%;align-items:center;float:inline-end;justify-content: center;">
      <!-- <span style="width: 100%;display: inline-block;">{{jobsListWithSubJobs.length}}/{{totalJobsCount}}</span> -->
      <pagination
          v-if="totalJobsCount > -1"
          v-model="page"
          :records="totalJobsCount"
          :per-page="jobsPerPage"
          :options="options"
          style="margin-top:10px"
      />
      <!-- @paginate="paginate" -->
    </div>
    </div>
    </div>
  </div>
  <div v-if="isJobDetailsVisible">
    <router-view 
      name="job-details"
      v-bind="jobCompleteDetails"
      @close="closeModal"
      :userMap="userMap">
    </router-view>
  </div>
</div>
</template>

<script>
import { mapActions,mapGetters,mapMutations } from "vuex";
// import Utils from "../../components.utils.js"
import Constants from "../../components.constants.js"
import Utils from "../../components.utils.js"
import Pagination from "vue-pagination-2";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import cancelIcon from "../core/InlineCancelField.vue";
import Multiselect from 'vue-multiselect';
import userMultiSelect from "../users/UserMultiselectField.vue"
import moment from 'moment';

export default {
  components:{
    "user-multi-select":userMultiSelect,
    "Datepicker":DatePicker,
    'cancel-icon':cancelIcon,
    pagination: Pagination,
    Multiselect,
  },
  data(){
    return {
      dropdownOpenDirection: "below",
      choosePriority:false,
      licenseExpMess:undefined,
      jobsList:[],
      subJobsList: [],
      isLoadMore:false,
      userMap:[],
      filterBy:{
        state:"All",
        job_name:"All"
      },
      jobsToShow: 10,
      userListFromAutocomplete:[],
      userGroupListFromAutocomplete:[],
      searchByUser:"",
      showUserFilter:false,
      fileNameFilter:"",
      time1:null,
      unFoldJobsMap:{},
      unFoldAllJobs:false,
      isClosed:false,
      isJobDetailsVisible:false,
      jobInfo: null,
      activeIndex:null,
      isUnfold:[],
      isClicked:false,
      isAllJobsFold:false,
      allJobsStatuses:[],
      page:1,
      firstLevelJobs:[],
      mapFistLevelWithSubLevelJobs:{},
      jobsListWithSubJobs:[],
      inProgressJobsCount:0,

      selectedJobStatus : {
        label:"All",
        job_status:"All"
        },
      selectedJobName : {
          _id:"All",
          label:"All",
          action_name:"All"
        },
      // selectedJobName : "All",
      searchKey:[],
      loggedInUserList:[],
      selectedParamsInfo:{},
      parentRouteInfo:{},
      currentRouteInfo:{},
      priorityMapper:[{"id":1,"value":"Highest"},
        {"id":2,"value":"High"},
        {"id":3,"value":"Medium"},
        {"id":4,"value":"Low"},
        {"id":5,"value":"Lowest"}],
      isGroupFolded:{},
      // totalJobsCount : 0,
      // jobsPerPage:0,
      options:{chunk:5},
      totalPages: -1,
      totalJobsCount: -1,
      jobsPerPage: -1,
    };
  },
  watch:{
    "$route.fullPath" : function(newVal, oldVal){
      if (newVal != oldVal){
        if (this.$route.name == "job-details"){
          this.showJob(this.$route.params.jobId)
        }else{
          this.handleJobsBrowse()
        }
      }
    }
  },
  props:["closeModalComponent"],
  computed:{
    jobCompleteDetails(){
      return {selectedJobInfo:this.jobInfo}
    },
    ...mapGetters("users",["getLoggedInUserPrivilege"])
  },
    methods:{
    getUUIDFromUtils(){
      return Utils.getUUID();
    },
    async showJob(jobId, push=false){
      let jobSelected = this.jobsListWithSubJobs.filter((job)=>job.job_id==this.$route.params.jobId)
      if (jobSelected.length == 0){
        jobSelected =  Object.values(this.mapFistLevelWithSubLevelJobs).filter((job)=>job.job_id==this.$route.params.jobId)
      }
      if (jobSelected.length == 0){
        let job = await this.getJobInfoFromServer({params:{jobId:jobId}})
        jobSelected = [job.job]
      }
      this.showSelectedJobDetails(jobSelected[0], push)
    },
    style(name){
      let style = {
        'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
        'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
      }
      return style
    },
    humaniseSize(bytes){
      if([undefined, null].includes(bytes)){
        return '-';
      }
      let data = Utils.humanizeSize(bytes)
      return `${data["value"]} ${data["unit"]}`
    },
    humanizeBandwidth(bytes){
      return Utils.humanizeBandwidth(bytes);
    },
    closeModal() {
      this.isJobDetailsVisible = false;
      this.activeIndex = null;
      if (Object.keys(this.currentRouteInfo).length !=0 ){
        if('jobId' in this.currentRouteInfo.params){
          delete this.currentRouteInfo.params.jobId;
        }
        this.$router.push({
          // name:this.currentRouteInfo.name,
          name: 'jobs',
          params:this.currentRouteInfo.params,
          query:this.currentRouteInfo.query
          })
        Object.assign(this.currentRouteInfo, {})
      }else{
        this.$router.push({name:"jobs"})
      }
    },
    showSelectedJobDetails(jobDetails, push=true){
      this.choosePriority = ""
      this.jobInfo = jobDetails;
      this.selectedJobInfo = jobDetails
      this.activeIndex = jobDetails._id;
      this.isJobDetailsVisible = true;
      if(push){
        Object.assign(this.currentRouteInfo, this.$route)
        let jobParam = {};
        jobParam["jobId"] = jobDetails.job_id;
        this.$router.push({
          name:"job-details",
          params:jobParam,
        })
      }
    },
    loadMoreJobs() {
      this.page = parseInt(this.page) + 1;
      let query = Object.assign({}, this.$route.query)
      this.$router.push({
        query:Object.assign(query, {page:this.page})
      })
    },
    searchResourceName(){
      let query = Object.assign({}, this.$route.query)
      if (this.filterBy.resource_name && this.filterBy.resource_name != undefined && this.filterBy.resource_name.length !=0){
        this.$router.push({
          query:Object.assign(query, {page:1, resource_name:this.filterBy.resource_name})
        })
      }else if (Object.keys(query).includes("resource_name")){
        delete query.resource_name
        this.$router.push({
          query:Object.assign(query, {page:1})
        })
      }
    },
    resetPageNumber(){
      this.page = 1;
    },
    updateJobNameFilter(option){
      this.selectedJobName = option;
      let query = Object.assign({}, this.$route.query)
      this.$router.push({
        query:Object.assign(query, {page:1, job_name:option.action_name})
      })
    },
    updateStatusFilter(option){
      this.selectedJobStatus=option;
      let query = Object.assign({}, this.$route.query)
      this.$router.push({
        query:Object.assign(query, {page:1, state:option.job_status})
      })
    },
    // updateFoldJobsMap(groupid){
    //   this.isClicked = true;
    //   let foldeUnfoldIconChange = this.isUnfold;
    //   let index = foldeUnfoldIconChange.indexOf(groupid);
    //   let testElements = document.getElementsByClassName('sub'+groupid);
    //   let tempGroupFoldUnfoldObj = {}
    //   Array.prototype.filter.call(testElements, function(testElements){
    //   if(testElements.style.display == "table-row" && index > -1){
    //     delete tempGroupFoldUnfoldObj[groupid];
    //     testElements.style.display = "none";
    //     foldeUnfoldIconChange = foldeUnfoldIconChange.filter(el => el != groupid);
    //   }else{
    //     if(!tempGroupFoldUnfoldObj[groupid]){
    //       tempGroupFoldUnfoldObj[groupid] = groupid;
    //     }
    //     testElements.style.display = "table-row";
    //     foldeUnfoldIconChange.push(groupid);
    //   }
    //   });
    //   this.isGroupFolded = tempGroupFoldUnfoldObj;
    //   console.log("this.isGroupFoldedthis.isGroupFolded",this.isGroupFolded)
    //   this.isUnfold = foldeUnfoldIconChange;
    // },
    updateFoldJobsMap(groupid){
      document.getElementsByClassName("sub"+groupid).forEach(function(element){
          element.style.display = 'none';
      });
      delete this.isGroupFolded[groupid];
      if(this.$refs['fold'+groupid][0])this.$refs['fold'+groupid][0].style.display = 'unset'
      if(this.$refs['unfold'+groupid][0])this.$refs['unfold'+groupid][0].style.display = 'none'
    },
    updateUnFoldJobsMap(groupid){
      document.getElementsByClassName("sub"+groupid).forEach(function(element){
          element.style.display = 'table-row';
      });
      
      if(!this.isGroupFolded[groupid]){
        this.isGroupFolded[groupid] = groupid;
      }
      if(this.$refs['unfold'+groupid][0])this.$refs['unfold'+groupid][0].style.display = 'unset'
      if(this.$refs['fold'+groupid][0])this.$refs['fold'+groupid][0].style.display = 'none'
    },
    retryJob(jobInfo){
      let payload = {params:{jobId: jobInfo._id}};
      this.retryfailedJob(payload).then((data)=>{
        if (data.statusCode == 200) {
          this.$toast.success(data.message);
        } else {
          this.$toast.error(data.message);
        }
      })
    },
    foldAndUnfoldAllJobs(){
      this.isClicked = true;
      if(this.isUnfold.length){
        this.isUnfold = [];
      }else{
        return false;
      }
    },
    getJobNames(){
       let jobsNameList = []
       for(let eachJob of this.getActionListFromInMem().filter((action)=>action.executed_as_job == true)){
        if((eachJob.action_name == 'Bulk Field Update' && this.isViewJobPrivExists("tag-metadata")) ||
          this.isViewJobPrivExists(eachJob.action_name)){
          jobsNameList.push(eachJob)
        }
       }
       if(this.isViewJobPrivExists("Export")){
         jobsNameList.push({
          label: "Export",
          action_name: "Export"
        })
        jobsNameList.push({
          label: "Export Proxy",
          action_name: "Export Proxy"
        })
       }
       if(this.isViewJobPrivExists('Lock/Unlock')){
        jobsNameList.push({
          label: "Lock/Unlock",
          action_name: "Lock/Unlock"
        })
       }
       if(this.isViewJobPrivExists("dam-core-routes")){
         jobsNameList.push({
          label: "Catalog Properties",
          action_name: "Catalog Properties"
          })
          jobsNameList.push({
            label: "Folder Properties",
            action_name: "Folder Properties"
          })
       }

       if(this.isViewJobPrivExists('reports')){
        jobsNameList.push({
          label: "Generate Reports",
          action_name: "Generate Reports"
        })
       }else{
        jobsNameList.push({
          label: "Generate Session Reports",
          action_name: "Generate Session Reports"
        })
       }
       
       jobsNameList.unshift({
          label:"All",
          action_name:"All"
        });
      return jobsNameList;
    },
    getJobStates(){
      return Constants.jobStates
    },
    formatedDate(date){
      // return moment.utc(date).format("DD-MMM-YYYY hh:mm A")
      return Utils.getDateTimeFormat(date);
    },
    getUserNameFromId(userId){
      let userInfoList = this.userMap.filter(map => map.user_id == userId)
      if(userInfoList.length > 0){
        return userInfoList[0].username;
      }
      return ""
    },
    isViewJobPrivExists(actionName){
      return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege, actionName);
    },
    handleUpdatedUsersList(user){
      this.selectedUsersList = [];
      this.filterBy.user_id = user._id;
      let query = Object.assign({}, this.$route.query)
      this.$router.push({
        query:Object.assign(query, {page:1, user_id:user._id})
      })
    },

    clearDateRangeFilter(){
      this.filterJobsByDate()
    },

    filterJobsByDate(dateRange=null){
      this.time1 = dateRange
      if(typeof dateRange != "undefined" &&
        dateRange != null && dateRange.length == 2 && dateRange[0] != null){
          let query = Object.assign({}, this.$route.query)
          this.$router.push({
            query:Object.assign(query, {
              page:1, 
              from_date:dateRange[0],
              to_date:dateRange[1]
              })
          })
      }else if(Object.keys(this.filterBy).includes("from_date")){
        this.isClicked = false;
        delete this.filterBy.from_date
        delete this.filterBy.to_date
        let query = Object.assign({}, this.$route.query)
        if("from_date" in query){
          delete query.from_date
        } 
        if("to_date" in query){
          delete query.to_date
        }
          this.$router.push({
            query:Object.assign(query, {
              page:1, 
              })
          })
      }

    },
    updateJobsListFromServer(onPageClick){
      this.showUserFilter = false
      let payload = {}
      let paramsInfo = JSON.parse(JSON.stringify(this.filterBy));
      // if(e && e != undefined){
      //   if(e.job_status != undefined){
      //     this.selectedJobStatus = e;
      //     paramsInfo["state"] = e.job_status;
      //   }
      //   if(e.action_name != undefined){
      //     this.selectedJobName = e;
      //     paramsInfo["job_name"] = e.action_name;
      //   }  
      //   if(e._id != undefined){
      //     this.searchKey = e.username
      //     paramsInfo["user_id"] = e._id;
      //   }
      // }
      if(Object.keys(paramsInfo).includes("user_id") &&
      (paramsInfo.user_id.trim() <= 0 || paramsInfo.user_id == 'all')){
        this.isClicked = false;
        delete paramsInfo.user_id
      }
      if(Object.keys(paramsInfo).includes("resource_name") && paramsInfo.resource_name.trim() <= 0){
        this.isClicked = false;
        delete paramsInfo.resource_name
      }
      if(Object.keys(paramsInfo).includes("job_name") &&
       (paramsInfo.job_name.trim() <= 0 || paramsInfo.job_name.trim() == 'All')){
        this.isClicked = false;
        delete paramsInfo.job_name
      }
      if(Object.keys(paramsInfo).includes("state") &&
       (paramsInfo.state.trim() <= 0 || paramsInfo.state.trim() == 'All')){
        this.isClicked = false;
        delete paramsInfo.state
      }
      
      if(onPageClick){
          paramsInfo['page'] = this.page;
      }else{
          paramsInfo['page'] = 1;
      }
      payload.params = paramsInfo;
      let selectedParams = paramsInfo;
      this.selectedParamsInfo = selectedParams;
      this.getAllJobsFromServer(payload).then((data)=>{
        this.totalJobsCount = data.total_jobs;
        this.jobsPerPage = data.jobs_per_page;
        if(data.page_count > 1 && this.page < data.page_count){
          this.isLoadMore = true;
          if(onPageClick == true){
            //  if(this.jobsList != undefined && this.jobsList.length > 0 && Object.keys(paramsInfo).includes("page") == true){
                this.getModifiedJobsListWithMapper(data.jobs,true) //on loadmore button click
              // }else{
              //   this.jobsList = data.jobs;
              //   this.getModifiedJobsListWithMapper(this.jobsList,true);//first page
              // }
          }else{
            // if(this.jobsList != undefined && this.jobsList.length > 0 && Object.keys(paramsInfo).includes("page") == true){
              this.getModifiedJobsListWithMapper(data.jobs,false) //on loadmore button click
            // }else{
            //   this.jobsList = data.jobs;
            //   this.getModifiedJobsListWithMapper(this.jobsList,false);//first page
            // }
          }
        }else{
          this.isLoadMore = false;
          this.jobsList = data.jobs;
          if(onPageClick == true){
            this.getModifiedJobsListWithMapper(this.jobsList,true); //on filters applied
          }else{
            this.getModifiedJobsListWithMapper(this.jobsList,false); //on filters applied
          }
        }
        this.userMap = data.user_map;
      });
    },
    getLicenseErrorMessage(){
      this.getLicensesListFromServer().then((response) => {
        if (Utils.isAcceptedStatusCode(response.statusCode)) {
          if(response.license.length > 0 && 'message' in response.license[0]){
            this.licenseExpMess = response.license[0]["message"]
          }
        }
      });
    },
    getModifiedJobsListWithMapper(jobs,isAppendToList,onNotification){
      this.firstLevelJobs = [];
      let orderedJobs = jobs.reduce((returnArray, jobs) => {if(!returnArray[jobs.group_id]){returnArray[jobs.group_id] = []; }
      returnArray[jobs.group_id].push(jobs);return returnArray;},[]); //rearranges data as [a:{num:1},b:{num:4},c:{num:3}]
      let groupsMapper = {};
      for(let key in orderedJobs){
        this.firstLevelJobs.push(orderedJobs[key][0]); //first level jobs
        groupsMapper[orderedJobs[key][0].group_id] = orderedJobs[key];
        if(this.isClicked || this.isUnfold.length)this.isUnfold.push(orderedJobs[key][0].group_id);
        // if(this.jobsListWithSubJobs.length && this.jobsListWithSubJobs[this.jobsListWithSubJobs.length-1].group_id == orderedJobs[key][0].group_id){
        //   for(let g=0; g<orderedJobs[key].length; g++){
        //     if(orderedJobs[key][g].group_id == this.jobsListWithSubJobs[this.jobsListWithSubJobs.length-1].group_id){
        //       this.mapFistLevelWithSubLevelJobs[orderedJobs[key][0].group_id].push(orderedJobs[key][g]);
        //       this.firstLevelJobs = this.firstLevelJobs.filter(e => e.group_id != orderedJobs[key][g].group_id)
        //     }
        //   }
        // }else{
          this.mapFistLevelWithSubLevelJobs[orderedJobs[key][0].group_id] = orderedJobs[key]; //mapper which provides all jobs with same group id
          if(groupsMapper[orderedJobs[key][0].group_id].length >= 1){
            this.mapFistLevelWithSubLevelJobs[orderedJobs[key][0].group_id].shift(); //removes first job (used to display subjobs)
          }
        // }
      }
      if(onNotification){
        this.jobsListWithSubJobs = this.firstLevelJobs.concat(this.jobsListWithSubJobs); //On notification
      }else{
         if(isAppendToList){
          this.jobsListWithSubJobs = this.jobsListWithSubJobs.concat(this.firstLevelJobs); //concats if loadmore button is clicked
          }else{
            this.jobsListWithSubJobs = this.firstLevelJobs; //first page
          }
      }
    },
    close() {
      // this.$emit('closeModal');
      this.isClosed = true
      if (Object.keys(this.parentRouteInfo)!=0 && Object.keys(this.parentRouteInfo).includes("name") ){
        this.$router.push({
          name: this.parentRouteInfo.name,
          params:this.parentRouteInfo.params,
          query:Object.assign({}, this.parentRouteInfo.query?this.parentRouteInfo.query:{}),
        })
      }else{
        this.$router.push({
          name: "explorer",
        })
      }
      // this.resetToOldCallback()
      // this.unsetModule({module: "jobs"});
    },
    handleUrlChange(){
      if (!(this.isClosed)){
        let jobsInfo = Utils.getHashLocationForJobs()
        if (Object.keys(jobsInfo).length != 0) {
          //No need of writing anything here
        }else{
          this.close()
        }
      }
    },
    updateProgress(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      let job_info = notification.message
      let job = this.jobsListWithSubJobs.filter((job_)=>job_.job_id == job_info.job_id);
      if (job.length != 0){
        job = job[0]
        Object.assign(job, job_info);
      }else{
        let paramsInfo = JSON.parse(JSON.stringify(this.filterBy));
        if((Object.keys(paramsInfo).includes("user_id") && (paramsInfo.user_id == 'all' || paramsInfo.user_id == job_info.user_id))
        && (Object.keys(paramsInfo).includes("job_name") && (paramsInfo.job_name ==  job_info.job_name || paramsInfo.job_name == 'All'))
        && (Object.keys(paramsInfo).includes("state") && (paramsInfo.state ==  job_info.state || paramsInfo.state == 'All'))
        && ((Object.keys(paramsInfo).includes("resource_name") && paramsInfo.resource_name.trim() <= 0) || (Object.keys(paramsInfo).includes("resource_name") && job_info.resource_name.includes(paramsInfo.resource_name)) || !Object.keys(paramsInfo).includes("resource_name"))){
          if(paramsInfo.from_date && job_info.created_datetime){
            const startDate = paramsInfo.from_date;
            const endDate = paramsInfo.to_date;
            const checkDate = job_info.created_datetime;
            if (checkDate >= startDate && checkDate <= endDate) {
                this.getModifiedJobsListWithMapper([job_info],false,true)
            }
          }else{
              this.getModifiedJobsListWithMapper([job_info],false,true)
          }
      }
    }
    },


    decideOpenDirection(e,refId){
      this.$nextTick(()=>{
        let divRef = this.$refs[refId][0].$el.getBoundingClientRect();
        if(divRef.y > 410){
          this.dropdownOpenDirection = "above";
        }else{
          this.dropdownOpenDirection = "below";
        }
      })
    },
    editPriority(jobId){
      this.choosePriority = jobId
      let refId = "priority"+jobId
      if(this.$refs[refId][0]){
        this.$refs[refId][0].$el.focus()
      }
    },
    handleJobPriority(event, jobid, groupId = null){
      let payload = {params:{jobId: jobid}, priority:event.id};
      this.choosePriority = ""
      this.updateJobPriority(payload).then((data)=>{
        if (data.statusCode == 200) {
          console.log("handleJobPriority", groupId)
          let jobDetails = null;
          if(groupId){
            let indx = this.mapFistLevelWithSubLevelJobs[groupId].findIndex(op=>op.job_id == jobid)
            jobDetails = this.mapFistLevelWithSubLevelJobs[groupId].filter(op=>op.job_id == jobid)
            if(indx >= 0){
              jobDetails[0].priority = event.id
              this.$set(this.mapFistLevelWithSubLevelJobs[groupId],  indx, jobDetails[0])
            }
          }else{
            let indx = this.jobsListWithSubJobs.findIndex(op=>op.job_id == jobid)
            jobDetails = this.jobsListWithSubJobs.filter(op=>op.job_id == jobid)
            if(indx >= 0){
              jobDetails[0].priority = event.id
              this.$set(this.jobsListWithSubJobs, indx, jobDetails[0])
            }
          }
          this.$toast.success('Successfully changed the job priority.');
        } else {
          this.$toast.error('Failed to change the job priority. ');
        }
      })
    },
    getPriorityVal(priorityId){
      let option = this.priorityMapper.filter(op=>op.id == priorityId)
      if(option){
        return option.value
      }
      return ""
    },
    getPriorityIcon(priority){
             let priorityIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up" viewBox="0 0 16 16">
                                  <path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z" fill="#f7ab00" stroke="#f7ab00"/>
                                </svg>`;
                if(priority == "Highest"){
                    priorityIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up" viewBox="0 0 16 16">
                                      <path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z" fill="#fb3a0e" stroke="#fb3a0e"/>
                                    </svg>`;
                }else if(priority == "High"){
                    priorityIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up" viewBox="0 0 16 16">
                                      <path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z" fill="#fb572f" stroke="#fb572f"/>
                                    </svg>`;
                }else if(priority == "Medium"){
                    priorityIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up" viewBox="0 0 16 16">
                                      <path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z" fill="#f7ab00" stroke="#f7ab00"/>
                                    </svg>`;
                }else if(priority == "Low"){
                    priorityIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16"  stroke="#b5b5b5">
                                      <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"/>
                                    </svg>`;   
                }else if(priority == "Lowest"){
                    priorityIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16" stroke="#808080">
                      <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"/>
                    </svg>`;   
                }

            return priorityIcon;
        },


    handleJobsBrowse(fromCreated=false){
      this.choosePriority = ""
      let route_params = Object.assign({}, this.$route.params), query=Object.assign({}, this.$route.query)
      this.page = query.page?query.page:1
      if (query && query.user_id){
        this.filterBy.user_id = query.user_id
      }else{
        this.filterBy.user_id = this.getLoggedInUserId();
      }
      if (query && query.resource_name){
        this.filterBy.resource_name = query.resource_name
      }
      if (query && query.from_date && query.to_date){
        this.filterBy.to_date = query.to_date+"T00:00:00"
        this.filterBy.from_date = query.from_date+"T00:00:00"
        if(moment(new Date()).format("YYYY-MM-DD") == query.to_date || query.from_date == query.to_date){
            this.filterBy.to_date = query.to_date+"T23:59:59"
        }
        this.time1 = [query.from_date, query.to_date]

      }
      if (query && query.job_name){
        let queryJobName = query.job_name?query.job_name:"All";
        this.filterBy.job_name = query.job_name?query.job_name:"All"
        if(queryJobName == "All"){
          this.selectedJobName = {
            _id:"All",
            label:"All",
            action_name:"All"
          }
        }else{
          for(let opJob of this.getJobNames()){
            if(opJob.label == queryJobName){
              this.selectedJobName = opJob;
            }
          }
        }
      }
      if (query && query.state){
        this.selectedJobStatus = {label:query.state, job_status:query.state};
        this.filterBy.state = query.state?query.state:"All"
      }
      this.updateJobsListFromServer(this.page&&this.page>1?true:false)
      if (fromCreated && route_params && route_params.jobId){
        this.showJob(route_params.jobId, true)
      }
    },
    ...mapActions("settings", ["getLicensesListFromServer"]),
    ...mapActions("jobs", ["getAllJobsFromServer","getAllJobsStatusFromServer", "getJobInfoFromServer","retryfailedJob","updateJobPriority"]),
    ...mapActions("users", ["getAllUsersFromServer","getUsersAutoComplitionFromServer"]),
    ...mapGetters("privileges",["getActionListFromInMem"]),
    ...mapGetters("users",["getLoggedInUser","getLoggedInUserId"]),
    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
    ...mapMutations("locations", ["setLocationHash", "unsetModule","changeLocationCallback", "resetToOldCallback","unsetLocationChangeEventListenerCallback"])
    },
  created() {
    this.getLicenseErrorMessage();
    Object.assign(this.parentRouteInfo, this.$route.params.parentinfo?this.$route.params.parentinfo:{})
    this.addWSEventListener({eventname:Constants.jobStatusUpdateNotification, callback:this.updateProgress,parent:"Jobs"})
    this.searchByUser = this.getLoggedInUser();
    // this.filterBy.user_id = this.getLoggedInUserId();
    this.loggedInUserList.push({"username":this.getLoggedInUser(),"_id":this.getLoggedInUserId()});
    this.showUserFilter = false;
    this.getAllJobsStatusFromServer().then((data)=>{
        this.allJobsStatuses = data.job_statuses;
        this.allJobsStatuses.unshift({
          label:"All",
          job_status:"All"
        });
        this.handleJobsBrowse(true)
    });
  },
  beforeDestroy(){
    this.removeWSEventListener({eventname:Constants.jobStatusUpdateNotification, callback:this.updateProgress,parent:"Jobs"})
  }
}
</script>


<style scoped lang="scss">
    $table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;
$secondary-border-hover-color:#767676;
  
  .modal{
      display:block;        
  }

  
  .modal-dialog {
    max-width:100%;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
  }
  
  .modal-header .close {
    // margin: -1rem -13px -1rem auto !important;
    padding: 0px;
    margin: 0px !important;
  }
  .modal-content {
    height: 100%;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    pointer-events: all;
    background: $primary-background !important;
  }

  .modal-header,.modal-footer{
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    background: $secondary-background-color;
  }

  .underline-on-hover:hover{
    span{
      text-decoration: underline;
    }
  }

  .search-bar-comm-style {
    height: 30px;
    position: relative;
    input {
      border: $border-color !important;
      position: absolute;
      // top: 12%;
      inset-inline-start:2%;
      height: 25px;
      padding-inline-start: 10px;
    }
    svg {
      position: absolute;
      inset-inline-start:12px;
      top: 34%;
    }
  }

.modal-header{
  height:65px;
}
.modal-body {
  height:calc(100% - 65px);
  display:inline-block;
  width:100%;

}

  .activeclass {
    color: $active-blue;
  }

  .ccomm-logs-row:hover{
    color: $active-blue;
  }

  .autocomplete-box{
      background: #0c0c0c;
      width: 100% !important;
      border: 1px solid #1e1e1e;
      height:100px;
      overflow:auto;
      z-index: 99999;
      ul{
        background: #0c0c0c;
        .list-group-item{
          background: #0c0c0c;
          font-size: 12px;
          color: #9a9a9a;
        }
        .list-group-item:hover{
          color: $active-blue;
        }
      }
  }
  .value-style {
        color: $text-color;
        width: 97%;
        text-align: start;
        padding-top: 3px;
        padding-bottom: 3px;
        padding-inline-end: 5px;
  }

  .filter-fields-in-logs{
    display:inline-flex;
    div.comm-div{
      display:inline-flex;
      width:25%;
      // padding-top:7px;
      position: relative;
      inset-inline-end: 2%;
      label{
        color:$dull-text-color;
        position: relative;
        inset-inline-end: 3px;
        width:30%;
        text-align:end;
        top:9px;
      }
      select,input{
        width:70%;
        height:38px;
        border:$border-color !important;
      }
      input:hover{
        border: 1px solid $secondary-border-hover-color !important;
      }
    }
    li{
      margin-inline-start: 4px
    }
  }
  .table-scroll {
    /*width:100%; */
    border: none !important;
    /* Decoration */
    border-spacing: 0;
    width: 100%;
    thead {
      color: $dull-text-color !important;
      position: relative;
      th{
        position: sticky;
        top: 0;
        background: $primary-background;
        z-index:9;
        text-align: start;
      }
    }
    tbody {
      width: 100%;
      overflow: auto;
      font-weight: 500;
      tr{
      height:40px;
      }
    }
  }

  .table{
    th{
      border-top:none !important;
    }
    td{
      border-top:none !important;
    }
  }

  .table-with-border {
    thead {
      border-bottom: $border-color;
    }
    tr {
      border-bottom: $border-color;
    }
  }

  .comm-user-row:hover {
    color: $active-blue;
    td:first-child {
      text-decoration: underline;
    }
  }

  .user-logs-table{
    height: calc(100vh - 170px);
    overflow:auto;
  }
  .height-set-for-component {
    height: calc(100% - 170px);
  }

  .search-bar-comm-style {
    height: 30px;
    position: relative;
    input {
      border: $border-color !important;
      position: absolute;
      // top: 12%;
      inset-inline-start:2%;
      height: 25px;
      padding-inline-start: 11%;
    }
    svg {
      position: absolute;
      inset-inline-start:12px;
      top: 40%;
    }
  }

  .jobs-info-icon{
    visibility:hidden;
  }
  .priority-icon{
    visibility:hidden;
  }


  .ccomm-logs-row:hover {
    .jobs-info-icon{
      visibility:visible;
    }
    .priority-icon{
      visibility: visible;
    }
  }

  .comm-sub-job-rows td:first-child{
    position: relative;
    inset-inline-start:1.8%;
  }
  .comm-sub-job-rows{
    height:60px;
    display:none;
  }
  /* width */
    ::-webkit-scrollbar {
    width: 8px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
    background: $scrollbar-track-background;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
    background: $scrollbar-thumb-on-hover-background;
    }

  .activestatus {
    color: #28a745 !important;
  }

  // //pagination

  .user-name-or-image{
    height: 30px;
    width: 30px;
    border: $border-color;
    border-radius: 10px;
    text-align: center;
    line-height: 28px;
    text-transform: uppercase;
    margin-top: 3px;
  }

  .user-name{
      margin-inline-end: 10px;
      position: relative;
      bottom: 7px;
  }
  
  input:focus{
    outline:none;
    box-shadow: none;
  }

  .priority-wrapper{
    position: relative;
    svg.svg-icon {
        width: 20px;
        height: 20px;
    }
  }

  ::v-deep{

  .mx-input{
      background-color:$primary-background !important;
      border: none !important;
      color: #eee !important;
      height:100%
  }
  .mx-input:focus{
    outline:none;
    box-shadow: none;
  }
  .mx-input-wrapper{
    width:100%;
    display: inline-flex;
    height: 100%;
  }
  .mx-datepicker-main{
      border: 1px solid #2f2f2f !important;
      background: $primary-background !important;
  }
  .mx-calendar-content .cell:hover{
      background-color: #505050 !important;
  }
  .mx-datepicker-range{
    width:100%
  }
  .mx-calendar-content .cell:hover {
      color: #000000;
      background-color: #7d99b1;
  }
  .mx-datepicker{
    width:100% !important;
    padding: 0 !important;
    border:$border-color !important;
    height: 38px !important;
  }
  .mx-datepicker:hover, mx-datepicker-range:hover{
    border:1px solid $secondary-border-hover-color !important;
  }
  .mx-icon-calendar, .mx-icon-clear{
        color: #d7d2d280;
  }
  } 

  ::v-deep {
  .page-item.disabled .page-link {
    background-color: $secondary-background-color !important;
    border: $border-color !important;
    // border: none;
  }
  .page-item.active .page-link {
    background-color: $secondary-background-color !important;
    // border: none !important;
    border: $border-color !important;
    color: $active-blue;
    z-index: 0 !important;
  }
  .page-link {
    background-color: $secondary-background-color !important;
    border: $border-color !important;
    // border: none !important;
    color: $text-color;
    padding: 5px !important;
  }
  .page-link:hover {
    background-color: $bg-color-on-hover !important;
  }
  .pagination {
    float: inline-end;
    margin-bottom: 0px !important;
    margin-inline-end: 8px;
  }
  .VuePagination__count {
    color: $secondary-text-color !important;
    margin-bottom: 0px !important;
    font-size: 12px;
    margin-inline-end: 7px;
    margin-top: 1px;
    float: inline-start;
    // display: none;
    display: inline-block !important;
    margin-inline-start: 5px;
  }
  .VuePagination__pagination{
    display:none !important;
  }
  .VuePagination__pagination-item {
    font-size: 14px;
    width: 27px;
  }
  .VuePagination__pagination-item-prev-chunk {
    display: none;
  }
  .VuePagination__pagination-item-next-chunk {
    display: none;
  }

  .VuePagination__pagination-item-prev-page {
    width: 50px !important;
  }

  .VuePagination__pagination-item-next-page {
    width: 50px !important;
  }

  .VuePagination__pagination-item-next-page a:before {
    width: 50px;
    content: "next ";
  }

  .VuePagination__pagination-item-prev-page a:after {
    width: 50px;
    content: " prev";
  }
  .deployment-bins{
    visibility: hidden;
  }
  .deployment-bins:hover{
    visibility: visible;
  }
  .v-list {
    padding: 0px !important;
  }
  .v-list-item {
    text-align: start;
    border: $secondary-border-color !important;
    min-height: 37px !important;
    padding: 0 10px !important;
    font-size: 12px !important;
    .v-list-item__title {
      font-size: 14px !important;
      color: $text-color !important;
    }
  }
  .v-menu__content {
    width: 190px !important;
  }
  }

  .close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
}
  .load-more-btn{
      width: 120px;
      height: 29px;
      padding: 0px;
      position: relative;
      top: 5px;
      background: $primary-background;
      font-size: 14px;
      inset-inline-start:100px;
  }

  .progress{
    width:65%;
    height:14px;
    background: #292929;
    margin-inline-end:3px;
  }

  li {
      width: 30%;
      display: inline-flex;
      // margin-bottom: 20px;
  }

  .config-label {
      width: 26% !important;
      text-align: end;
      color: #757575;
      word-break: break-word;
      position: relative;
      align-items: center;
      display: inline-flex;
      justify-content: end;
  }
  
  .config-value {
      margin-inline-start: 4px;
      width: 75% !important;
      display:grid;
      svg{
          position: relative;
          top: 9px;
          margin-inline-start: 10px;
      }
  }

   ::v-deep {
        .multiselect:hover .multiselect__tags{
          border: 1px solid $secondary-border-hover-color !important;
        }

        .commDefaultdropDownFields{
            width:auto;
            display: inline-block;
            .multiselect__tags, .multiselect__select{
                border: none !important;
                background: transparent !important;  
                background-color: transparent !important; 
                // padding:0px;
            }
            .multiselect__tags{
                padding-inline-end:10px;
            }
            .multiselect__select{
                display: none;
            }
            .multiselect__content-wrapper{
                display: none;
            }
        }
        .multiselect__tag {
            background-color: $primary-background !important;
        }
        .multiselect__tags{
            background: $primary-background !important;
            border: $border-color !important;
            padding: 0px 40px 0 0px !important;
        }
        .multiselect__option--highlight {
           background: $bg-color-on-hover !important;
        }
        .multiselect__content {
            background: $secondary-background-color !important;
        }
        .multiselect__input, .multiselect__single {
            background: transparent !important;
            color:$text-color;
            align-items: center;
            margin:0px !important;
            height: 100%;
            padding-inline-start: 5px;
        }
        .multiselect__single {
          margin: 0px !important;
          height: 100%;
          display: flex;
          align-items: center;
          padding-top:0px;
        }  
        .multiselect__input:focus{
          outline:none;
          box-shadow: none;
        }
        .multiselect__tag-icon{
          color:$text-color !important;
        }
        .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
            background: $bg-color-on-hover !important;
            color:$text-color !important;
        }
        .multiselect__tag-icon:after{
          color:$secondary-text-color  !important;
          font-size: 23px;
        }
        .multiselect *{
            font-size: 14px !important;
            font-family: "Roboto", Arial, sans-serif !important;
        }
        .multiselect{
        color:#eee !important;
        font-size: 12px !important;
        height: $input-field-height;
        min-height: $input-field-height;
        // width:250px;
        }
        .multiselect__option--selected{
            background: $bg-color-on-hover!important;
            color: #eee;
        }
        .multiselect__content-wrapper{
            // border: 1px solid #292828 !important;
             border: 1px solid $bg-color-on-hover !important;
            position: absolute;
            display: block;
            background: $text-color;
            width: 100%;
            max-height: 240px !important;
            overflow: auto;
            border: 1px solid $text-color;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            z-index: 50;
            -webkit-overflow-scrolling: touch;
        }
        .multiselect__select,.multiselect__current,.multiselect__option{
            line-height: 12px !important;
        }
        .multiselect--above .multiselect__content-wrapper{
        background: $secondary-background-color !important;
        }
        .multiselect__tags {
            background: $primary-background;
            padding-inline-start: 0px !important;
            height: $input-field-height;
            min-height: $input-field-height;
            display: flex;
            align-items: center;
            margin:0px !important;
            height: 100%;
            padding-inline-start: 5px;
        }

        .multiselect__placeholder{
          display: flex;
          align-items: center;
          margin:0px !important;
          height: 100%;
          padding-inline-start: 5px;

        }
    }
    .refresh-action{
      height: 36px;
      margin: 0px 10px;
      width: 100px;
      align-items: center;
      font-size:14px;
    }

    .unFoldIcon{
      position:relative;
      inset-inline-end:3px;
      display: none;
    }

</style>
